// extracted by mini-css-extract-plugin
export default {"element":"LayoutRow-module--element--46bf9","capped":"LayoutRow-module--capped--fb245"};